<div class="page-container">
  <div class="d-flex flex-column">
    <div class="py-lg-2 px-md-1 px-xl-4 position-relative">
      <kbxl-shipping-search-criteria
        [criteria]="pagingUiHelper.filter$ | async"
        [equipment]="equipment$ | async | toTreeNodes"
        [states]="states$ | async"
        [isMobile]="isMobile$ | async"
        [serviceTypes]="serviceTypes$ | async"
        (search)="search($event)"
        (clear)="clear()"
        [showExport]="true"
        (export)="exportData()"
      ></kbxl-shipping-search-criteria>
    </div>
    <kbxl-color-bar></kbxl-color-bar>
    <div class="grid-container px-xl-4 px-1">
      <kbxl-shipping-grid
        [loading]="loading$ | async"
        [gridData]="loads$ | async"
        [isDeliveredLoads]="true"
        [user]="user$ | async"
        [serviceTypes]="serviceTypes$ | async"
        (selected)="selected($event)"
        kbxlActionCheck="loadshop.ui.shopit.load.viewdelivereddetail"
        (isDisabledChange)="isDisabled = $event"
        enforcementType="disable"
        (lazyLoad)="onLazyLoadEvent($event)"
        [lazy]="true"
        (documentChange)="pagingUiHelper.reloadData()"
      ></kbxl-shipping-grid>
    </div>
    <!-- <div class="construction-message">
            <fa-icon [icon]="['fas', 'tools']" size="2x"></fa-icon>
            <span>Under Construction</span>
        </div> -->
  </div>
</div>
<router-outlet></router-outlet>
